import { useState } from 'react';
import WechatModal from '../../../components/feature/WechatModal';
import { ComplianceTab } from '../types';

interface ComplianceCTAProps {
  onOpenDrawer: () => void;
  activeTab: ComplianceTab;
}

export default function ComplianceCTA({ onOpenDrawer, activeTab }: ComplianceCTAProps) {
  const [wechatOpen, setWechatOpen] = useState(false);

  const getTabLabel = (tab: ComplianceTab) => {
    switch (tab) {
      case 'customs':
        return '关务';
      case 'tax':
        return '税务';
      case 'forex':
        return '外汇';
      default:
        return '';
    }
  };

  return (
    <>
      <section className="py-16 bg-gradient-to-br from-teal-50 via-white to-emerald-50">
        <div className="max-w-[1400px] mx-auto px-6 text-center">
          <h3 className="text-3xl font-bold text-gray-900 mb-4">
            获取你的合规治理升级方案
          </h3>
          <p className="text-gray-600 mb-10 max-w-2xl mx-auto">
            根据您的业务形态与治理需求，我们将为您匹配最适合的合规治理方案组合
          </p>
          <div className="flex items-center justify-center gap-4">
            <button
              onClick={onOpenDrawer}
              className="px-8 py-3 bg-[#14B8A6] text-white text-sm font-medium rounded-full hover:bg-teal-600 transition-all cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl"
            >
              咨询合规治理方案
            </button>
            <button
              onClick={() => window.REACT_APP_NAVIGATE('/capabilities')}
              className="px-8 py-3 bg-white text-gray-700 text-sm font-medium rounded-full border border-gray-300 hover:border-[#14B8A6] hover:text-[#14B8A6] transition-all cursor-pointer whitespace-nowrap"
            >
              查看产品及价格
            </button>
            <button
              onClick={() => setWechatOpen(true)}
              className="text-sm text-gray-600 hover:text-[#14B8A6] transition-all cursor-pointer whitespace-nowrap underline"
            >
              先跑通一票（9.9/99）
            </button>
          </div>
        </div>
      </section>

      <WechatModal isOpen={wechatOpen} onClose={() => setWechatOpen(false)} />
    </>
  );
}